/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gatewayStat', [])
    .factory('gatewayStatisticsService', GatewayStatisticsService)
    .name;

/*@ngInject*/
function GatewayStatisticsService($http, $q) {

    var service = {
        getGatewayStatistics: getGatewayStatistics,
        getGatewayStatisticsScroll: getGatewayStatisticsScroll
    };

    return service;

    function getGatewayStatistics(mac, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/gateway/mac/${mac}/statistics?startTs=${startTs}&endTs=${endTs}&limit=${limit}&page=${page}`;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getGatewayStatisticsScroll(mac, startTs, endTs, limit, page) {
        var deferred = $q.defer();
        var url = `/api/gateway/mac/${mac}/stats?startTs=${startTs}&endTs=${endTs}&limit=${limit}&page=${page}`;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/gateway-statistics.service.js